var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    { staticClass: "elevation-0" },
    [
      _c(
        "v-row",
        { staticClass: "pt-5", attrs: { justify: "space-between" } },
        [
          _c("v-card-subtitle", [
            _vm._v(
              " Samples to show the power of the Heimdall application and supported OHDF formats. "
            ),
          ]),
          _c(
            "v-btn",
            {
              staticClass: "mr-8 ml-2 mt-2",
              attrs: { icon: "", small: "" },
              on: {
                click: function ($event) {
                  _vm.isActiveDialog = true
                },
              },
            },
            [
              _c(
                "v-icon",
                {
                  attrs: {
                    "b-tooltip.hover": "",
                    title: "Filter Instructions",
                    color: "primary",
                  },
                },
                [_vm._v(" mdi-information-outline ")]
              ),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { width: "500" },
              model: {
                value: _vm.isActiveDialog,
                callback: function ($$v) {
                  _vm.isActiveDialog = $$v
                },
                expression: "isActiveDialog",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [_vm._v("Filter Instructions")]),
                  _c("v-card-text", { staticClass: "text-h7" }, [
                    _vm._v(
                      " Sample entries can be filtered by entering the value into the search input text field. The result of the filtering process will include entries not currently visible (on another page). "
                    ),
                    _c("br"),
                    _c("br"),
                    _c("b", [_vm._v("NOTE:")]),
                    _vm._v(
                      " To clear the search, either click the clear icon (X) or simply delete any value(s) from the input box. "
                    ),
                  ]),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          on: {
                            click: function ($event) {
                              _vm.isActiveDialog = false
                            },
                          },
                        },
                        [_vm._v("Close Dialog")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("v-container", { staticClass: "mx-0 px-0" }, [
        _c("div", [
          _c(
            "div",
            { staticClass: "ma-0 pa-0" },
            [
              _c("v-text-field", {
                staticClass: "px-3 pb-1",
                attrs: {
                  "prepend-inner-icon": "mdi-magnify",
                  hint: "Filter on file name",
                  placeholder: "file name",
                  clearable: "",
                  "hide-details": "auto",
                  "data-cy": "fileSearchField",
                },
                model: {
                  value: _vm.search,
                  callback: function ($$v) {
                    _vm.search = $$v
                  },
                  expression: "search",
                },
              }),
              _c(
                "div",
                { staticClass: "d-flex flex-column" },
                [
                  _c("v-data-table", {
                    staticClass: "pb-8 table",
                    attrs: {
                      "data-cy": "loadSampleFileList",
                      dense: "",
                      "show-select": "",
                      "fixed-header": "",
                      "mobile-breakpoint": "0",
                      headers: _vm.headers,
                      items: _vm.samples,
                      search: _vm.search,
                      "sort-by": _vm.sortBy,
                      "sort-desc": _vm.sortDesc,
                      loading: _vm.loading,
                      "item-key": _vm.fileKey,
                      height: _vm.tableHight,
                      "header-props": _vm.headerprops,
                      "footer-props": {
                        showFirstLastPage: true,
                        firstIcon: "mdi-page-first",
                        lastIcon: "mdi-page-last",
                        prevIcon: "mdi-chevron-left-circle-outline",
                        nextIcon: "mdi-chevron-right-circle-outline",
                        itemsPerPageText: "Rows per page:",
                      },
                    },
                    on: {
                      "update:sortBy": function ($event) {
                        _vm.sortBy = $event
                      },
                      "update:sort-by": function ($event) {
                        _vm.sortBy = $event
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: `header.filename`,
                          fn: function ({ header }) {
                            return [
                              _vm._v(
                                " " + _vm._s(header.text.toUpperCase()) + " "
                              ),
                              header.sortable
                                ? _c(
                                    "v-icon",
                                    {
                                      staticClass:
                                        "v-data-table-header__icon page-of-pages-div",
                                      attrs: { medium: "" },
                                    },
                                    [_vm._v(" mdi-sort ")]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                        {
                          key: "footer",
                          fn: function ({ props }) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pr-10 text-right page-of-pages-div",
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      " Page " +
                                        _vm._s(props.pagination.page) +
                                        " of " +
                                        _vm._s(props.pagination.pageCount) +
                                        " "
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.filename`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass: "cursor-pointer",
                                  on: {
                                    click: function ($event) {
                                      return _vm.load_samples([item])
                                    },
                                  },
                                },
                                [_vm._v(" " + _vm._s(item.filename) + " ")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                    model: {
                      value: _vm.selectedFiles,
                      callback: function ($$v) {
                        _vm.selectedFiles = $$v
                      },
                      expression: "selectedFiles",
                    },
                  }),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { top: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "card-outter",
                                      attrs: {
                                        block: "",
                                        disabled: _vm.loading,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.load_samples(
                                            _vm.selectedFiles
                                          )
                                        },
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _vm._v(" Load Selected "),
                                  _c("v-icon", { staticClass: "pl-2" }, [
                                    _vm._v("mdi-file-download"),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [_c("span", [_vm._v("Load selected items(s)")])]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }